import { Loader as Assets } from '@CS/assets';
import Spinner from '@CS/assets/loader.svg?component';
import LottieAnimation from '@CS/components/LottieAnimation';
import { LoaderStyle, ImageStyle, SpinnerStyle } from './Loader.styles';

export type LoaderProps = {
  overlay?: boolean;
  opacity?: number;
  image?: string;
  color?: string;
  speed?: number;
  width?: number;
  lottie?: JSON;
};

export const Loader = ({
  overlay = false,
  color = 'white',
  opacity = 0.5,
  speed = 2.5,
  width = 50,
  lottie,
  image
}: LoaderProps) => {
  const loader = lottie ? (
    <ImageStyle width={width}>
      <LottieAnimation animationData={Assets.lottie} />
    </ImageStyle>
  ) : image ? (
    <ImageStyle width={width}>
      <img src={Assets.gif} />
    </ImageStyle>
  ) : (
    <SpinnerStyle color={color} speed={speed} width={width}>
      <Spinner />
    </SpinnerStyle>
  );

  return (
    <LoaderStyle $overlay={overlay} opacity={opacity}>
      {loader}
    </LoaderStyle>
  );
};
